"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _context = require("../../context");

var _utils = require("../../utils");

var _constants = require("../constants");

var _utils2 = require("../utils");

var _interfaces = require("./interfaces");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var Tick = (0, _context.styledWithTheme)('div')(function (_ref) {
  var checked = _ref.checked,
      colorScheme = _ref.colorScheme,
      disabled = _ref.disabled,
      error = _ref.error,
      isWithoutInput = _ref.isWithoutInput,
      _ref$theme = _ref.theme,
      isInHighContrast = _ref$theme.isInHighContrast,
      selectors = _ref$theme.selectors;
  var isInverted = colorScheme === _interfaces.CheckboxColorScheme.Inverted;

  var getColor = function getColor(color) {
    return color === 'transparent' ? color : selectors.color(color);
  };

  var getColorParams = {
    disabled: disabled,
    error: error,
    getColor: getColor,
    isInverted: isInverted
  };
  var backgroundColor = (0, _utils2.getBackgroundColor)(getColorParams);
  var borderColor = (0, _utils2.getBorderColor)(getColorParams);
  var focusColor = (0, _utils2.getFocusColor)(getColorParams);
  var checkedBorderColor = (0, _utils2.getCheckedBorderColor)(getColorParams);
  var checkedBackgroundColor = (0, _utils2.getCheckedBackgroundColor)(getColorParams);
  var indeterminateBarColor = (0, _utils2.getIndeterminateBarColor)(getColorParams);
  var tickColor = (0, _utils2.getTickColor)(getColorParams);
  var borderRadius = selectors.radius('R100');
  var outlineStyle = (0, _utils.addOutline)(_constants.OUTLINE_BORDER_WIDTH, 1, focusColor, {
    width: 1,
    color: tickColor
  });
  var colorStyles = {
    backgroundColor: backgroundColor,
    border: "".concat((0, _utils.px)(_constants.CHECKBOX_BORDER_WIDTH), " solid ").concat(borderColor)
  };
  var checkedColorStyles = {
    backgroundColor: checkedBackgroundColor,
    borderColor: checkedBorderColor
  };
  var tickCheckedStyles = {
    strokeDasharray: '15, 20000',
    opacity: 1
  };
  var focusStyles = {
    'input:focus-visible ~ &': outlineStyle.focus,
    'input:checked:focus ~ &': {
      backgroundColor: focusColor
    },
    'input:indeterminate:focus-visible ~ &': {
      '.stencilIndeterminateBar': {
        backgroundColor: focusColor
      }
    }
  };
  var hoverStyles = {};

  if (!disabled) {
    var hoverColor = (0, _utils2.getHoverColor)(getColorParams);
    hoverStyles = isWithoutInput ? {
      ':hover': _objectSpread({
        borderColor: hoverColor
      }, checked && {
        backgroundColor: hoverColor
      })
    } : {
      'input:hover ~ &': {
        borderColor: hoverColor
      },
      'input:checked:hover ~ &': {
        backgroundColor: hoverColor
      },
      'input:indeterminate:hover ~ &': {
        '.stencilIndeterminateBar': {
          backgroundColor: hoverColor
        }
      }
    };
  }

  return _objectSpread(_objectSpread(_objectSpread({
    width: (0, _utils.px)(_utils.A11Y_INLINE_MIN_SIZE),
    height: (0, _utils.px)(_utils.A11Y_INLINE_MIN_SIZE),
    borderRadius: borderRadius,
    boxSizing: 'border-box',
    position: 'absolute',
    top: 0,
    left: 0,
    transition: 'border-color 0.1s, background-color 0.1s, box-shadow 0.1s',
    svg: _objectSpread({
      display: 'block',
      position: 'absolute'
    }, isInHighContrast && disabled ? {
      backgroundColor: _constants.WHCM_DISABLED_ITEM_COLOR,
      top: '-2px',
      left: '-2px'
    } : {
      left: '50%',
      top: '50%',
      transform: 'translate(-50%, -50%)'
    }),
    '.tick': _objectSpread({
      opacity: 0,
      stroke: isInHighContrast ? _constants.WHCM_ITEM_COLOR : tickColor,
      strokeDasharray: '0, 20000',
      transition: 'stroke-dasharray 0.2s, opacity 0.2s',
      transitionDelay: '0.1s',
      transitionTimingFunction: 'ease'
    }, isWithoutInput && checked && tickCheckedStyles)
  }, isWithoutInput ? _objectSpread(_objectSpread({}, colorStyles), checked && checkedColorStyles) : {
    'input ~ &': colorStyles,
    'input:indeterminate ~ &': {
      borderColor: checkedBorderColor,
      '.stencilIndeterminateBar': {
        opacity: 1,
        backgroundColor: indeterminateBarColor
      }
    },
    'input:checked ~ &': _objectSpread(_objectSpread({}, checkedColorStyles), {}, {
      '.tick': tickCheckedStyles
    })
  }), focusStyles), hoverStyles);
});
var _default = Tick;
exports.default = _default;